import { Directive, ElementRef, forwardRef, Attribute, EventEmitter, Output } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';
@Directive({
  selector: '[mainerror][formControlName],[mainerror][formControl],[mainerror][ngModel]',
  inputs: ['list', 'showError'],
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => MainError), multi: true }
  ]
})
export class MainError implements Validator {
  list;
  showError: object = {};
  constructor( @Attribute('mainerror') public errorObject: object, public _el: ElementRef) {
  }
  @Output() ngModelChange: EventEmitter<any> = new EventEmitter()

  validate(c: AbstractControl): { [key: string]: any } {
    let v = this._el.nativeElement.value;
    let list = this.list;
    let err = {}, errorFlag = false, redBorderFlag = false;
    let pos = this._el.nativeElement['selectionStart'] || 1;

    if (list.hasOwnProperty('maxCharStop') && v.length > list['maxCharStop']) {
      // this._el.nativeElement.value = this._el.nativeElement.value.slice(0, list['maxCharStop']);
      this._el.nativeElement.value = this.spliceSlice(this._el.nativeElement.value, pos - 1, 1)

      //      this.showError['maxCharStop'] = true;
      //      redBorderFlag = true;
      //      setTimeout(() => {
      //        this.showError['maxCharStop'] = false;
      //      }, 3000)
    } else if (list.hasOwnProperty('maxCharStop'))
      this.showError['maxCharStop'] = false;


    if (list.hasOwnProperty('startOnlyAlpha') && list['startOnlyAlpha'] && v.length) {
      let r = new RegExp(/^[a-zA-Z]+$/);
      if (!r.test(v[0])) {
        this._el.nativeElement.value = this._el.nativeElement.value.slice(1);
        this.showError['startOnlyAlpha'] = true;
        setTimeout(() => {
          this.showError['startOnlyAlpha'] = false;
        }, 3000);
        // err['startOnlyAlpha'] = true;
        // setTimeout(() => {
        //   err['startOnlyAlpha'] = false;
        // }, 3000)
        errorFlag = true;
        redBorderFlag = true;
      } else if (list.hasOwnProperty('startOnlyAlpha')) {
        err['startOnlyAlpha'] = false;
        this.showError['startOnlyAlpha'] = false;
      }
    } else if (list.hasOwnProperty('startOnlyAlpha')) {
      err['startOnlyAlpha'] = false;
      this.showError['startOnlyAlpha'] = false;
    }

    if (list.hasOwnProperty('startWithAlphaNum') && list['startWithAlphaNum'] && v.length) {
      let r = new RegExp(/^[a-zA-Z0-9]([\s\S]?)+/);
      if (!r.test(v[0])) {

        this._el.nativeElement.value = this._el.nativeElement.value.slice(1);
        this.showError['startWithAlphaNum'] = true;
        setTimeout(() => {
          this.showError['startWithAlphaNum'] = false;
        }, 3000);
        err['startWithAlphaNum'] = true;
        errorFlag = true;
        redBorderFlag = true;
      } else if (list.hasOwnProperty('startWithAlphaNum')) {
        err['startWithAlphaNum'] = false;
        this.showError['startWithAlphaNum'] = false;
      }
    } else if (list.hasOwnProperty('startWithAlphaNum')) {
      err['startWithAlphaNum'] = false;
      this.showError['startWithAlphaNum'] = false;
    }

    if (list.hasOwnProperty('nospace') && list['nospace'] && (v[v.length - 1] == ' ' || v.indexOf(' ') != -1)) {
      if (v[v.length - 1] == ' ')
        this._el.nativeElement.value = this._el.nativeElement.value.slice(0, v.length - 1);
      else {
        this._el.nativeElement.value = this._el.nativeElement.value.replace(/ /g, '');
      }
      this.showError['nospace'] = true;
      redBorderFlag = true;
      setTimeout(() => {
        this.showError['nospace'] = false;
      }, 3000)
    } else if (list.hasOwnProperty('nospace'))
      this.showError['nospace'] = false;

      if (list.hasOwnProperty('cspattern') && list['cspattern'] && v.length && !this.showError['startOnlyAlpha'] && !err['startWithAlphaNum']) {
      let r = new RegExp(list['cspattern']);
      if (!r.test(v)) {
        this._el.nativeElement.value = this.spliceSlice(this._el.nativeElement.value, pos - 1, 1)
        // this._el.nativeElement.value = this._el.nativeElement.value.replace(r,'');

        this.showError['cspattern'] = true;
        setTimeout(() => {
          this.showError['cspattern'] = false;
        }, 3000);
        redBorderFlag = true;
      } else if (list.hasOwnProperty('cspattern'))
        this.showError['cspattern'] = false;
    }
    if (list.hasOwnProperty('cpattern') && list['cpattern'] && v.length && !err['startOnlyAlpha']) {
      let r = new RegExp(list['cpattern']);
      if (!r.test(v)) {
        //          this._el.nativeElement.value = this._el.nativeElement.value.replace(`/${r}/g`, '')
        this.showError['cpattern'] = true;
        setTimeout(() => {
          this.showError['cpattern'] = false;
        }, 3000);
        redBorderFlag = true;
      } else if (list.hasOwnProperty('cpattern'))
        this.showError['cpattern'] = false;
    }
    if (list.hasOwnProperty('checkpattern') && list['checkpattern'] && v.length && !err['startOnlyAlpha']) {
      let r = new RegExp(list['checkpattern']);
      if (!r.test(v)) {
        //          this._el.nativeElement.value = this._el.nativeElement.value.replace(`/${r}/g`, '')
        err["checkpattern"] = true;
        errorFlag = true;
      } else {

      }
    }
    if (list.hasOwnProperty('crequired') && !this._el.nativeElement.value) {/// for required validation
      err["crequired"] = true;
      errorFlag = true;
    }
    if (list.hasOwnProperty('cminlength') && this._el.nativeElement.value.length < list['cminlength'] && this._el.nativeElement.value) {//for min length validation
      err['cminlength'] = true;
      errorFlag = true;
    } else if (list.hasOwnProperty('cminlength') && this._el.nativeElement.value.length >= list['cminlength']) {
      err['cminlength'] = false;
    }

    if (list.hasOwnProperty('noZeroStart') && list['noZeroStart']) {
      if (this._el.nativeElement.value[0]=="0") {
        let index = this._el.nativeElement.value.lastIndexOf(0);
        this._el.nativeElement.value = this._el.nativeElement.value.slice(index + 1, this._el.nativeElement.value.length);
        this.showError['noZeroStart'] = true;
        redBorderFlag = true;
        setTimeout(() => {
          this.showError['noZeroStart'] = false;
        }, 3000)
      }
    } else if (list.hasOwnProperty('noZeroStart'))
      this.showError['noZeroStart'] = false;

    if (redBorderFlag == true) {
      this._el.nativeElement.style.borderColor = "#ff0000";
      setTimeout(() => {
        this._el.nativeElement.style.borderColor = '#c2cad8';
      }, 3000);
    } else {
      this._el.nativeElement.style.borderColor = "#c2cad8";
      // Clear all errors when field is valid
      if (!errorFlag && v.length > 0) {
        if (list.hasOwnProperty('startOnlyAlpha')) this.showError['startOnlyAlpha'] = false;
        if (list.hasOwnProperty('startWithAlphaNum')) this.showError['startWithAlphaNum'] = false;
        if (list.hasOwnProperty('cspattern')) this.showError['cspattern'] = false;
        if (list.hasOwnProperty('cpattern')) this.showError['cpattern'] = false;
        if (list.hasOwnProperty('nospace')) this.showError['nospace'] = false;
        if (list.hasOwnProperty('maxCharStop')) this.showError['maxCharStop'] = false;
      }
    }

    this.ngModelChange.emit(this._el.nativeElement.value);
    return errorFlag ? err : null;
  }
  spliceSlice(str, index, count, add?) {
    // We cannot pass negative indexes dirrectly to the 2nd slicing operation.
    if (index < 0) {
      index = str.length + index;
      if (index < 0) {
        index = 0;
      }
    }

    return str.slice(0, index) + (add || "") + str.slice(index + count);
  }
}



// WEBPACK FOOTER //
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/common/directives/mainError.directive.ts